<template>
    <div class="container_fluid work mr-4 ml-4 p-2 pt-1">
    
      <Entry mainalign="left"  carouselid="A1" :maintitle="this.EntryTexts.A1.title" :maintext="this.EntryTexts.A1.text" :images="this.SlideshowImages.A1"></Entry>
      <Entry mainalign="right" carouselid="B2" :maintitle="this.EntryTexts.B2.title" :maintext="this.EntryTexts.B2.text" :images="this.SlideshowImages.B2"></Entry>
      <Entry mainalign="left"  carouselid="C2" :maintitle="this.EntryTexts.C2.title" :maintext="this.EntryTexts.C2.text" :images="this.SlideshowImages.C2"></Entry>
      <Entry mainalign="right" carouselid="C3" :maintitle="this.EntryTexts.C3.title" :maintext="this.EntryTexts.C3.text" :images="this.SlideshowImages.C3"></Entry>
      <Entry mainalign="left"  carouselid="D4" :maintitle="this.EntryTexts.D4.title" :maintext="this.EntryTexts.D4.text" :images="this.SlideshowImages.D4"></Entry>
      <Entry mainalign="right" carouselid="E5" :maintitle="this.EntryTexts.E5.title" :maintext="this.EntryTexts.E5.text" :images="this.SlideshowImages.E5"></Entry>
      <div class="col-sm align-center">
          <div class="row mt-5">
              <div class="col-sm">
                <a href="/#" class="ch-ui-but">back to top</a>
             </div>
          </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import Entry from '@/components/Entry.vue'
import { AppData } from '@/data.js'

export default {
  name: 'home',
  components: {
    Entry,
  },
  data (){
    return AppData;
  },
  computed: {
  },
  watch: {
  },
  mounted: function () {
   // console.log(this.SlideshowImages.A1)
  }
}
</script>

<style>
p {line-height: 1.2rem;}
h1.contact-title{
  font-size: 1rem;
  line-height: 1.1rem;
  font-weight: normal;
}
.contact-paragraph{
  line-height: 1.1rem;
}
.ch-ui-but{
    text-decoration: underline;
  color: inherit !important;
    line-height: 1.25rem;
  letter-spacing: 0.04rem;
}
</style>